<template>
  <div
    class="dui-loading-indicator loading-indicator"
    :class="[ vm.colorClass, size ]"
  >
    <span :class="loadingType" />
  </div>
</template>

<script>
import coloredComponent from '@dui/mixins/colored-component';

const DEFAULT_TYPE = 'spinner';

export default {
  mixins: [
    coloredComponent,
  ],
  props: {
    size: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
  },
  computed: {
    loadingType() {
      const type = this.type ? this.type : DEFAULT_TYPE;
      return `loading-${ type }`;
    },
  },
};
</script>
